<template>
  <div class="copyright">
    COPYRIGHT (C) 2006 National Institute of Health Sciences ALL RIGHTS
  </div>
</template>

<script>
export default {
  name: 'Copyright',
}
</script>

<style scoped lang="scss">
.copyright {
  background-color: #fff;
  font-size: 10px;
  white-space: nowrap;
  height: 25px;
  text-align: center;
  line-height: 2.5em;
  position: absolute;
  left: 0;
  right: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  @media all and (max-width: 320px) {
    font-size: 8px;
  }
}
</style>
